import React, { Component } from 'react';
import './EztSplash.css';

class EztSplash extends Component {

    
    render() {
        return (
            <div className = 'SplashContainer' >
                <div className = 'Splash' >
                    {this.props.splash ? <img className='SplashImg' alt = "EasyTerritory"/>
                        : <p>Loading...</p>
                    }

                </div>
            </div>
        );
    }
}

export default EztSplash;